export { zeroDataTransformer } from "./schema";
import { zeroDataTransformer } from "./schema";

export const createZero = zeroDataTransformer.createZero;
export const defineMutator = zeroDataTransformer.defineMutator;
export const defineMutators = zeroDataTransformer.defineMutators;
export const defineQueries = zeroDataTransformer.defineQueries;
export const defineQuery = zeroDataTransformer.defineQuery;
export const wrapTransaction = zeroDataTransformer.wrapTransaction;
